import { Byte } from '@angular/compiler/src/util';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ArtikelDokument } from '../../../store/models/artikeldokument';
import { ArtikelDokumenteService } from '../shared/artikeldokumente.service';

@Component({
    selector: 'kkis-app-artikeldokumente-list',
    templateUrl: './artikeldokumente-list.component.html',
    styleUrls: ['./artikeldokumente-list.component.scss']
})
export class ArtikeldokumenteListComponent implements OnInit, OnChanges {

    @Input()
    artikelKennung: number;

    // ArtikelDokument
    artikelDokumente: ArtikelDokument.IArtikelDokumentsDto;

    // Utils
    isLoading: boolean = true;

    constructor(
        private artikelDokumentService: ArtikelDokumenteService,
    ) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.artikelKennung != null && changes.artikelKennung.currentValue != null && changes.artikelKennung.currentValue != changes.artikelKennung.previousValue) {
            this.artikelKennung = changes.artikelKennung.currentValue;

            this.artikelDokumentService.getListForArtikel(this.artikelKennung).subscribe(res => {
                this.artikelDokumente = res;

                this.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    }
    
    onSelectArtikelDokument(artDok: ArtikelDokument.IArtikelDokumentListDto) {
        this.artikelDokumentService.getById(artDok.id).subscribe(res => {
            var url = URL.createObjectURL(res);
            window.open(url);
        });
    }

    getFiletype(input_filetype) {

        input_filetype = input_filetype.replace('.',''); 

        switch(input_filetype) {
            case 'docx':
                input_filetype = 'doc';
                break;
            case 'jpg':case 'jpeg': case'png': case 'bmp': case 'svg': case 'tga': case 'tiff': case 'gif': //...
                input_filetype = 'pic';
                break;
            case 'mp4':case 'avi': case'wmv': case 'avi': case 'flv': case 'mkv': case 'mov': //...
                input_filetype = 'vid';
                break;
            default:

          }
        
        return input_filetype;
      }
}
